import * as React from 'react';
import i18next from 'i18next';
import { Source } from 'config/services/sources.service';
import styles from './styles.module.scss';
import '../../i18n';

interface Props {
  sources: Source[];
  /** The selected Fuente; `null` is the "Plan Maestro" tab (every Acción). */
  selectedId: number | null;
  onSelect: (sourceId: number | null) => void;
}

/** "Plan Maestro" plus one tab per Fuente, keyboard-navigable as a WAI-ARIA tablist. */
const SourceTabs = ({ sources, selectedId, onSelect }: Props) => {
  const tabs = [{ id: null, label: i18next.t('home:planMaestro') as string },
    ...sources.map(s => ({ id: s.id as number | null, label: s.shortName }))];
  const refs = React.useRef<(HTMLButtonElement | null)[]>([]);
  const selectedIndex = Math.max(0, tabs.findIndex(t => t.id === selectedId));

  const moveTo = (index: number) => {
    const next = (index + tabs.length) % tabs.length;
    onSelect(tabs[next].id);
    refs.current[next]?.focus();
  };

  const onKeyDown = (event: React.KeyboardEvent) => {
    const keys: Record<string, number> = {
      ArrowRight: selectedIndex + 1, ArrowLeft: selectedIndex - 1, Home: 0, End: tabs.length - 1
    };
    if (event.key in keys) {
      event.preventDefault();
      moveTo(keys[event.key]);
    }
  };

  return (
    <div className={styles.tablist} role="tablist" aria-label={i18next.t('home:sourcesLabel') as string}>
      {tabs.map((tab, index) => {
        const selected = index === selectedIndex;
        return (
          <button
            key={tab.id === null ? 'plan' : tab.id}
            ref={el => { refs.current[index] = el; }}
            type="button"
            role="tab"
            aria-selected={selected}
            tabIndex={selected ? 0 : -1}
            className={`${styles.tab} ${selected ? styles.selected : ''}`}
            onClick={() => onSelect(tab.id)}
            onKeyDown={onKeyDown}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
};

export default SourceTabs;
